import { GuestModel } from './guest-model';

export class GuestGroupModel {
	constructor(
		readonly groupName : string,
		readonly guests : GuestModel[]) {
    guests.sort(function(a, b) {
      //sort by lastname and then firstname, putting guests with invalid names at the end

      let validNameA = a.hasValidFirstName() && a.hasValidLastName();
      let validNameB = b.hasValidFirstName() && b.hasValidLastName();
      if(!validNameA && validNameB)  {
        return 1;
      } else if (validNameA && !validNameB) {
        return -1;
      } else {
        let nameA = a.getLastName().toLowerCase();
        let nameB = b.getLastName().toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        let firstNameA = a.getFirstName().toLowerCase();
        let firstNameB = b.getFirstName().toLowerCase();
        if (firstNameA < firstNameB) {
          return -1;
        }
        if (firstNameA > firstNameB) {
          return 1;
        }
        return 0;
      }
    });
	}

}



// WEBPACK FOOTER //
// ./src/app/models/guestgroup-model.ts